import { BookIcon, HeartIcon, HomeIcon } from 'lucide-preact';
import { useDispatch } from 'react-redux';

import BellNotifications from '@/components/BellNotifications';
import BurgerMenu from '@/components/BurgerMenu';
import { selectHabitatForProductsPromptModal } from '@/components/HabitatLink/utils';
import TalkNavItem from '@/components/Header/TalkNavItem';
import NavItem from '@/components/NavBar/NavItem';
import NavMenuContent from '@/components/NavBar/NavMenuContent';
import NavMenuFooter from '@/components/NavBar/NavMenuFooter';
import { setProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/actions';
import { createSelectProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/selectors';
import { useSelector, useStore } from '@/redux/helper';
import { selectCanAccessEducatorsApp, selectIsFreeUser } from '@/redux/selectors/users';

import UserMenu from '../Menu';

const AuthenticatedHeaderContent = ({ isLargeScreen }: { isLargeScreen: boolean }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const canAccessEducatorsApp = useSelector(selectCanAccessEducatorsApp);
  const educatorsAppURL = useSelector((state) => state.remoteConfig.educatorsAppURL);
  const isFreeUser = useSelector(selectIsFreeUser);

  const educatorsAppLink = isLargeScreen
    ? educatorsAppURL
    : (() => {
        if (!educatorsAppURL) {
          return undefined;
        }
        const url = new URL(educatorsAppURL);
        url.pathname = '/about';
        return url.toString();
      })();

  return isLargeScreen ? (
    <>
      <nav>
        <ul className="preflight preflight-ul flex select-none items-center gap-6">
          {canAccessEducatorsApp ? (
            <>
              <li>
                <NavItem
                  avoidInnerPadding
                  text="Resources"
                  url={educatorsAppLink}
                  customIcon={<BookIcon className="size-5 text-stone-500 group-hover:text-stone-900" />}
                  data-tour="educator-resources"
                />
              </li>
            </>
          ) : (
            <li>
              <NavItem avoidInnerPadding text="Home" url="/home" customIcon={<HomeIcon className="size-5" />} />
            </li>
          )}
          <li>
            <NavItem avoidInnerPadding text="My Animals" url="/habitats" customIcon={<HeartIcon className="size-5" />} />
          </li>
          <li>
            <TalkNavItem avoidInnerPadding />
          </li>
        </ul>
      </nav>
      <div className="ml-9 flex items-center gap-4">
        {isFreeUser ? (
          <div>
            <button
              type="button"
              onClick={() => {
                const state = store.getState();
                const habitat = selectHabitatForProductsPromptModal(state);
                const modalState = createSelectProductsPromptModalState(habitat?._id)(state);
                dispatch(
                  setProductsPromptModalState({
                    ...modalState,
                    entryPoint: 'header',
                  }),
                );
              }}
              className="preflight preflight-button min-w-0 rounded-full bg-primary-green px-4 py-2 text-sm/4 font-medium text-white hover:bg-secondary-green"
            >
              Upgrade
            </button>
          </div>
        ) : null}
        <BellNotifications />
        <UserMenu />
      </div>
    </>
  ) : (
    <div className="ml-4 flex items-center gap-4">
      <BellNotifications />
      <BurgerMenu>
        <div>
          <NavMenuContent />
          <NavMenuFooter className="my-3" />
        </div>
      </BurgerMenu>
    </div>
  );
};

export default AuthenticatedHeaderContent;
